import { take, call, put } from 'redux-saga/effects';
import * as types from '../../lib/actionTypes.es6';
import { getClosedClaims } from '../../lib/requests.es6';
import * as actions from './actions.es6';
import { unAuthorizedNotification } from '../../lib/access.es6';
import { GAloggerException } from '../../lib/monitoring.es6';

/**
 * this saga continually watches register request actions
 */
export function* closedClaimRequestWatcher() {
  while (yield take(types.CLOSED_CLAIM_REQUEST)) {
    try {
      const response = yield call(getClosedClaims);
      yield put(actions.closedClaimsSuccess(response.data));
    } catch (e) {
      let errorPayload = {};
      if (e.response) {
        errorPayload = e.response.data;
        unAuthorizedNotification(e);
      }
      GAloggerException(e);
      yield put(actions.closedClaimsFail(errorPayload));
    }
  }
}
